import classNames from "classnames";
import "./DashboardCurtain.css";
import { useEffect, useState } from "react";
interface DashboardCurtainProps {
  show: boolean;
  onClick: () => void;
}

const DashboardCurtain: React.FC<DashboardCurtainProps> = ({
  show,
  onClick,
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    if (show) {
      // Synchro avec un systeme externe au rendu (DOM, storage, timer, toast,
      // navigation) : l'etat accompagne un effet de bord qui ne peut pas remonter au rendu.
      // eslint-disable-next-line react/set-state-in-effect
      setIsShown(true);
    } else {
      setIsClosing(true);
      setTimeout(() => {
        setIsClosing(false);
        setIsShown(false);
      }, 300);
    }
  }, [show]);

  return (
    <div
      className={classNames("dashboard-curtain", {
        show: isShown,
        isClosing: isClosing,
      })}
      onClick={() => onClick()}
    ></div>
  );
};

export default DashboardCurtain;
